/* ENDLESS PURE funnel kit v5 (9 Oct 2026): the resolver, the questions and the copy. Pasted verbatim from kit.js; do not edit here. */
window.EPFunnelKit = (function () {
  var holder = {
  /* ====== ENDLESS PURE FORK KIT v5 (9 Oct 2026) — shared by prototypes A–E and the theme. Paste verbatim as a class method; do not edit. ======
     One line per recommendation (PURE CALM or Bio-Retinol), three exits without a product, no diseases named.
     PURE CALM: R1 is the routine for sensitive skin, always three products (Oil-To-Milk Cleanser + Light + Night);
     R2 is the Light Moisturiser alone (hydration), R3 the Night Recovery Cream alone (barrier support). The goal picks, not skin type.
     kit().plan(answers, cfg)    -> which questions still have to be asked
     kit().resolve(answers, cfg) -> outcome R1–R6 or an exit, with the rule number and the mandatory notes
     v5: every visitor-facing sentence lives in COPY (English, the reference text). A translation is a dictionary with the same keys,
     set as window.EPFunnelCopy before the kit loads; a missing key falls back to English. Whole sentences only, never fragments:
     the kit never glues words together, so every language can reorder freely. [name] marks a value filled in at run time. */
  kit() {
    var IMG = {
      light: '/_blob/79191b871272935e13d9422400b54508',
      night: '/_blob/f616991ba5aac04e8fb9f640c80da268',
      serum: '/_blob/bab78e9f1f5a898c4e9023be0351ad3e',
      elixir: '/_blob/a1cf2c8ffeba21ab8efb4905e8202bdc',
      duo: '/_blob/dd8daf8facbba68c04973ea089848146',
      spf: '/_blob/ca7b77137e666752debfbf6a9db16cf8',
      oil: '/_blob/ba0fe7d3a8860f4cf6f0e8af910e97a3'
    };
    var COPY = {
      /* products: names stay in English in every language (brand and product names) unless the store sells them under another name */
      'p.C.name': 'Oil-To-Milk Cleanser',
      'p.C.cap': 'An oil that turns to milk on wet skin · organic camomile, cloudberry and sea buckthorn extracts · contains a light fragrance',
      'p.C.about': 'The first step: an oil that turns to milk on wet skin. With organic camomile, cloudberry and sea buckthorn extracts. Contains a light fragrance.',
      'p.L.name': 'PURE CALM Light Moisturiser',
      'p.L.cap': 'Enzymatically hydrolysed red algae · fermentation-made hyaluronic acid and Sodium PCA',
      'p.N.name': 'PURE CALM Night Recovery Cream',
      'p.N.cap': 'Enzymatically hydrolysed red algae · fermentation-made hyaluronic acid',
      'p.S.name': 'Bio-Retinol Serum',
      'p.S.cap': 'Bidens pilosa extract · fermentation-made hyaluronic acid',
      'p.E.name': 'Bio-Retinol Elixir Moisturiser',
      'p.E.cap': 'Bidens pilosa extract · fermentation-made Sodium PCA, hyaluronic acid and a marine exopolysaccharide',
      'p.DUO.name': 'Bio-Retinol DUO',
      'p.DUO.size': 'Serum 30 ml + Elixir 50 ml',
      'p.DUO.cap': 'Bidens pilosa extract in both steps · fermentation-made hydrators in support',
      'p.SPF.name': 'Sun Protection SPF50 Stick',

      /* questions: text, hint, option labels (o.<value>), reflections (r.<value>) */
      'q.derm': 'Then your dermatologist decides what goes on your skin. We make cosmetics, not treatments.',
      'q.S1.q': 'Why do you think your skin is sensitive?',
      'q.S1.hint': 'Six different things hide behind the word “sensitive”',
      'q.S1.o.derm': 'A dermatologist is looking after my facial skin',
      'q.S1.o.many_products': 'It stings, burns or turns red with many products, even simple ones',
      'q.S1.o.after_acids': 'It started after acids, a peel, retinol or a procedure',
      'q.S1.o.weather': 'It reacts to cold, wind, heat, indoor heating or hard water',
      'q.S1.o.selective': 'One or two products, or fragranced products, did not suit me',
      'q.S1.o.just_in_case': 'Just in case — no real reactions',
      'q.S1.r.many_products': 'That is reactive skin: the less it has to react to, the better.',
      'q.S1.r.after_acids': 'Then the cause is the routine, and it is temporary. Calm comes first.',
      'q.S1.r.weather': 'That usually points to dryness or dehydration rather than reactivity.',
      'q.S1.r.selective': 'So it is selective. We will check what exactly did not suit you.',
      'q.S1.r.just_in_case': 'Then “sensitive” is a label, not a limit. Your goal decides.',
      'q.S2.q': 'How does it show, and how long does it last?',
      'q.S2.hint': 'Choose all that apply',
      'q.S2.o.sting_minutes': 'Stinging or tingling that passes within an hour',
      'q.S2.o.redness_hours': 'Redness for a few hours',
      'q.S2.o.tight_flaky': 'Tightness and flaking',
      'q.S2.o.redness_days': 'Redness that stays for days',
      'q.S2.o.rash_itch': 'Breakouts, strong itching or weeping skin',
      'q.S2.r.ok': 'Short-lived reactions: that is within what gentle skincare can help with.',
      'q.S2.r.alarm': 'Redness that stays for days, breakouts, strong itching or weeping skin are questions for a dermatologist, not for a moisturiser.',
      'q.S3.q': 'How often does your skin react like this?',
      'q.S3.hint': 'Frequency separates reactive skin from an occasional bad match',
      'q.S3.o.almost_every': 'To almost every new product',
      'q.S3.o.sometimes': 'Sometimes',
      'q.S3.o.rarely': 'Rarely, in specific conditions',
      'q.S3.r.almost_every': 'Almost every new product: we treat your skin as reactive.',
      'q.S3.r.sometimes': 'Sometimes: your skin has limits, but it does not react to everything.',
      'q.S3.r.rarely': 'Rarely: your skin is mostly steady.',
      'q.Q1.q': 'How do you feel about scent in skincare?',
      'q.Q1.hint': 'Bio-Retinol is lightly fragranced; the PURE CALM creams are not',
      'q.Q1.o.avoid': 'I avoid fragrance and essential oils',
      'q.Q1.o.dislike': 'I don’t like scented products',
      'q.Q1.o.neutral': 'I don’t mind',
      'q.Q1.o.like': 'I like it',
      'q.Q1.r.avoid': 'Noted. We stay with PURE CALM: both creams are fragrance-free and essential-oil-free. Only the cleanser of its routine is lightly fragranced, and you can keep your own.',
      'q.Q1.r.dislike': 'Noted. We stay with PURE CALM: both creams are fragrance-free. Only the cleanser of its routine is lightly fragranced.',
      'q.Q1.r.neutral': 'Good — that keeps both lines open.',
      'q.Q1.r.like': 'Good — that keeps both lines open.',
      'q.Q2.q': 'How does your facial skin react to new products?',
      'q.Q2.hint': 'Decides whether a fragranced formula is an option at all',
      'q.Q2.o.often': 'It often stings or turns red',
      'q.Q2.o.sometimes': 'Sometimes',
      'q.Q2.o.rarely': 'Almost never',
      'q.Q2.r.often': 'Then we stay with PURE CALM, the routine for sensitive skin.',
      'q.Q2.r.sometimes': 'Then we first check what sets it off.',
      'q.Q2.r.rarely': 'Steady skin: your goal decides the line.',
      'q.Q3.q': 'Does any of this apply to you?',
      'q.Q3.hint': 'Two situations that change the answer',
      'q.Q3.o.derm': 'A dermatologist is looking after my facial skin',
      'q.Q3.o.pregnancy': 'I’m pregnant, planning a pregnancy or breastfeeding',
      'q.Q3.o.none': 'None of these',
      'q.Q3.r.pregnancy': 'We stay with PURE CALM. Please check your skincare with your doctor.',
      'q.Q3.r.none': 'Good — nothing changes the plan.',
      'q.Q4.q': 'Right now, is your skin flaking, tight or stinging after retinol, acids, a peel or a procedure?',
      'q.Q4.hint': 'Irritated skin needs calm before anything else',
      'q.Q4.o.yes': 'Yes',
      'q.Q4.o.no': 'No',
      'q.Q4.r.yes': 'Then calm comes first. Pause the acids and retinol for 2–4 weeks.',
      'q.Q4.r.no': 'Good — nothing to calm down first.',
      'q.Q5.q': 'What do you want to change first?',
      'q.Q5.hint': 'The goal picks the line and the product',
      'q.Q5.o.comfort': 'Comfort and less visible redness',
      'q.Q5.o.hydration': 'Hydration',
      'q.Q5.o.barrier': 'Tightness and flaking — support my skin barrier',
      'q.Q5.o.first_wrinkles': 'First lines',
      'q.Q5.o.marked_wrinkles': 'Deeper wrinkles and firmness',
      'q.Q5.r.comfort': 'That is the PURE CALM routine for sensitive skin: a cleanser and two creams.',
      'q.Q5.r.hydration': 'Water first: the Light Moisturiser carries the most water-binders of our creams.',
      'q.Q5.r.barrier': 'Lipids first: the Night Recovery Cream supports the skin’s moisture barrier.',
      'q.Q5.r.first_wrinkles': 'That is Bio-Retinol’s job — if your skin is steady and fragrance is not a problem.',
      'q.Q5.r.marked_wrinkles': 'That is Bio-Retinol’s job. A cream softens how lines look; it does not remove them.',
      'q.Q6.q': 'How would you describe your skin?',
      'q.Q6.hint': 'Skin type can change the answer',
      'q.Q6.o.oily': 'Oily or breakout-prone',
      'q.Q6.o.combination': 'Combination',
      'q.Q6.o.normal': 'Normal',
      'q.Q6.o.dry': 'Dry',
      'q.Q6.o.very_dry': 'Very dry: it flakes and cracks',
      'q.Q6.r.oily': 'Noted: thin layers work best on oily skin.',
      'q.Q6.r.combination': 'Noted: thin layers, a little more where skin is drier.',
      'q.Q6.r.normal': 'Noted: nothing here changes the plan.',
      'q.Q6.r.dry': 'Dry, but not flaking and cracking: our creams are an option.',
      'q.Q6.r.very_dry': 'We don’t have the right product for very dry skin yet, and we would rather say so.',
      'q.Q7.q': 'Do you use retinol?',
      'q.Q7.hint': 'Bio-Retinol is an alternative, not an add-on',
      'q.Q7.o.tolerate': 'Yes, and my skin tolerates it well',
      'q.Q7.o.quit': 'I stopped because of irritation',
      'q.Q7.o.never': 'I have never tried it',
      'q.Q7.r.tolerate': 'Then you don’t need an alternative.',
      'q.Q7.r.quit': 'Then a plant-based alternative is worth a try.',
      'q.Q7.r.never': 'Then your goal decides.',
      'q.sep': ' · ',

      /* outcomes */
      'out.R1.title': 'The PURE CALM routine for sensitive skin',
      'out.R1.short': 'Cleanser + Light + Night',
      'out.R1.lead': 'Three products, always the same three: the Oil-To-Milk Cleanser first, then the Light Moisturiser by day and the Night Recovery Cream in the evening.',
      'out.R1.cta': 'See my PURE CALM routine',
      'out.R1.bio': 'One marine biotech active, morning and night: enzymatically hydrolysed red algae in both creams, with hyaluronic acid made by fermentation.',
      'out.R2.title': 'PURE CALM Light Moisturiser',
      'out.R2.short': 'Light: hydration',
      'out.R2.lead': 'Hydration for sensitive skin: one light, fragrance-free cream, morning and evening.',
      'out.R2.cta': 'See my PURE CALM routine',
      'out.R2.bio': 'A light moisturiser built on enzymatically hydrolysed red algae and three fermentation-made hydrators: hyaluronic acid at two molecular weights and Sodium PCA.',
      'out.R3.title': 'PURE CALM Night Recovery Cream',
      'out.R3.short': 'Night: barrier support',
      'out.R3.lead': 'Barrier support for sensitive skin: the richer fragrance-free cream, every evening. It supports the skin’s moisture barrier.',
      'out.R3.cta': 'See my PURE CALM routine',
      'out.R3.bio': 'A richer night cream built on enzymatically hydrolysed red algae, with hyaluronic acid made by fermentation and organic mango seed butter.',
      'out.R4.title': 'Bio-Retinol Serum',
      'out.R4.short': 'Serum',
      'out.R4.lead': 'One light serum, morning and evening, after a patch test.',
      'out.R4.cta': 'See my Bio-Retinol routine',
      'out.R4.bio': 'A plant-based alternative to retinol: Bidens pilosa extract, supported by hyaluronic acid made by fermentation at two molecular weights.',
      'out.R5.title': 'Bio-Retinol Elixir Moisturiser',
      'out.R5.short': 'Elixir',
      'out.R5.lead': 'One richer cream, morning and evening, after a patch test.',
      'out.R5.cta': 'See my Bio-Retinol routine',
      'out.R5.bio': 'Bidens pilosa extract with three fermentation-made ingredients: Sodium PCA, hyaluronic acid at two molecular weights and a marine exopolysaccharide.',
      'out.R6.title': 'Bio-Retinol DUO',
      'out.R6.short': 'DUO',
      'out.R6.lead': 'Serum first, then the Elixir over it, morning and evening. Patch test before you start.',
      'out.R6.cta': 'See my Bio-Retinol routine',
      'out.R6.bio': 'Two steps, one extract: Bidens pilosa in both the serum and the cream, with fermentation-made hydrators in support.',

      /* exits */
      'exit.DOCTOR.head': 'This is a question for your dermatologist.',
      'exit.DOCTOR.text': 'We make cosmetics, not treatments, so we won’t recommend a product here.',
      'exit.DOCTOR.sub': 'Skin that is under a dermatologist’s care, redness that stays for days, breakouts, strong itching or weeping skin need a doctor’s eye first.',
      'exit.VERY_DRY.head': 'We don’t have the right product for very dry skin yet.',
      'exit.VERY_DRY.text': 'Neither of our two lines is built for skin that flakes and cracks, and we would rather say so than sell you the wrong cream.',
      'exit.VERY_DRY.sub': 'Skin like this needs a richer, more occlusive product than we make today.',
      'exit.RETINOL_OK.head': 'If retinol works for you, you don’t need an alternative.',
      'exit.RETINOL_OK.text': 'Bio-Retinol is for people retinol didn’t suit. Keep what works.',
      'exit.RETINOL_OK.sub': 'If comfort or hydration is what you are after, change your goal and we will show you PURE CALM.',

      /* mandatory notes */
      'note.eofree': 'Both PURE CALM creams are fragrance-free and essential-oil-free.',
      'note.cleanser': 'The Oil-To-Milk Cleanser contains a light fragrance.',
      'note.cleanserAvoid': 'You told us you avoid fragrance: both creams are fragrance-free, but the cleanser is lightly fragranced. You can keep your own fragrance-free cleanser instead.',
      'note.cleanserDislike': 'You told us you don’t like scented products: both creams are fragrance-free, but the cleanser is lightly fragranced. You can keep your own fragrance-free cleanser instead.',
      'note.fragrance': 'Contains a natural fragrance with geranium essential oil. If your skin reacts to fragranced products, choose PURE CALM.',
      'note.patch': 'Before first use, patch test on the inner forearm or behind the ear twice a day for 5–7 days. Not for the eyelids, irritated skin or skin just after a procedure.',
      'note.spf': 'None of these products contains SPF. Use a separate sunscreen in the morning.',
      'note.doctor': 'Please check your skincare with your doctor.',
      'note.reask': 'Pause acids and retinol, keep to this calm routine for 2–4 weeks, then take the questions again.',
      'note.full': 'The full PURE CALM routine for sensitive skin is three products: the Oil-To-Milk Cleanser and both creams.',

      /* skin profiles */
      'type.K.name': 'A question for your dermatologist',
      'type.R.name': 'Reactive skin',
      'type.R.diag': 'Your skin reacts first and asks questions later. Stinging and flushing are how it says “too much”.',
      'type.P.name': 'Over-treated skin',
      'type.P.diag': 'Acids, retinol or a procedure have pushed your skin past what it can take. It looks like sensitive skin, but the cause is the routine, and it is temporary.',
      'type.W.name': 'Dry-leaning skin',
      'type.W.diag': 'Your skin reacts to weather more than to products. That is dryness or dehydration rather than reactivity.',
      'type.I.name': 'Selective skin',
      'type.I.diag': 'One or two things did not suit you. The rest of the time your skin is steady.',
      'type.N.name': 'Steady skin',
      'type.N.diag': 'No real reactions. “Sensitive” was a precaution, not a description.',

      /* why you: one full sentence per case */
      'why.general': 'This is our general answer. It becomes yours as soon as the remaining questions are answered.',
      'why.R1.reactive': 'Your skin reacts to many products, so it gets our routine for sensitive skin, always the same three steps: the Oil-To-Milk Cleanser and both PURE CALM creams.',
      'why.R1.irritated': 'Your skin is irritated right now, so calm comes first. Pause acids and retinol and keep to our routine for sensitive skin, always the same three steps: the Oil-To-Milk Cleanser and both PURE CALM creams.',
      'why.R1.scent': 'You want to work on lines, but you prefer skincare without scent, and Bio-Retinol is fragranced. So we stay with PURE CALM: its two creams have no fragrance and no essential oils. Only the cleanser is lightly fragranced.',
      'why.R1.pregnancy': 'During pregnancy, planning or breastfeeding we stay with PURE CALM and its routine for sensitive skin, always the same three steps: the Oil-To-Milk Cleanser and both PURE CALM creams.',
      'why.R1.comfort': 'You asked for comfort and less visible redness. That is the PURE CALM routine for sensitive skin, always the same three steps: the Oil-To-Milk Cleanser and both PURE CALM creams.',
      'why.R1.default': 'You came with a question about sensitive skin. Our routine for it is always the same three steps: the Oil-To-Milk Cleanser and both PURE CALM creams.',
      'why.R2.asked': 'You asked for hydration. The Light Moisturiser is our hydration cream for sensitive skin: it carries the most water-binders of our creams.',
      'why.R2.default': 'This question is about hydration, and that is the Light Moisturiser’s job: it carries the most water-binders of our creams.',
      'why.R3.asked': 'You described tightness and flaking. The Night Recovery Cream is our barrier cream for sensitive skin: it supports the skin’s moisture barrier.',
      'why.R3.default': 'This question is about tight, flaking skin, and that is the Night Recovery Cream’s job: it supports the skin’s moisture barrier.',
      'why.BR.sometimes_E': 'You want to work on lines and your skin sometimes reacts, so we suggest one Bio-Retinol product, after a patch test: the richer Elixir for dry skin.',
      'why.BR.sometimes_S': 'You want to work on lines and your skin sometimes reacts, so we suggest one Bio-Retinol product, after a patch test: the Serum, the lighter of the two.',
      'why.R4': 'You want to work on lines, your skin is steady and scent is not a problem. Oily and combination skin gets the Serum alone: the Elixir is too rich.',
      'why.R5': 'You want to work on lines, your skin is steady and scent is not a problem. Dry skin gets the richer Elixir.',
      'why.R6': 'You want to work on lines, your skin is steady and scent is not a problem. The DUO is the full routine of the line: serum, then cream.',

      /* the three lines of the result card */
      'card.why': 'Why you',
      'card.bio': 'What is biotech here',
      'card.good': 'Good to know',
      'card.good.BR': 'Contains a natural fragrance with geranium essential oil. Patch test before first use.',
      'card.good.R1': 'Both PURE CALM creams are fragrance-free and essential-oil-free. The Oil-To-Milk Cleanser contains a light fragrance. Cosmetics, not a treatment.',
      'card.good.R1avoid': 'You told us you avoid fragrance: both creams are fragrance-free, but the cleanser is lightly fragranced. You can keep your own fragrance-free cleanser instead. Cosmetics, not a treatment.',
      'card.good.R1dislike': 'You told us you don’t like scented products: both creams are fragrance-free, but the cleanser is lightly fragranced. You can keep your own fragrance-free cleanser instead. Cosmetics, not a treatment.',
      'card.good.PC': 'Both PURE CALM creams are fragrance-free and essential-oil-free. A cosmetic moisturiser, not a treatment.',

      /* how it is made */
      'made.foot': 'Biotech describes how an ingredient is made. What it does for skin is stated separately, and more cautiously.',
      'made.PC.head': 'A marine active made by enzymatic hydrolysis.',
      'made.PC.1.process': 'Enzymatic hydrolysis',
      'made.PC.1.head': 'Red algae, broken down by enzymes',
      'made.PC.1.text': 'Enzymes cut the red algae extract into smaller, water-soluble fractions. This is the calming active in both PURE CALM creams. It helps calm the look of redness.',
      'made.PC.2.process': 'Fermentation',
      'made.PC.2.head': 'Hyaluronic acid at two molecular weights',
      'made.PC.2.headL': 'Hyaluronic acid and Sodium PCA',
      'made.PC.2.text': 'Hyaluronic acid at two molecular weights is made by fermentation.',
      'made.PC.2.textL': 'Hyaluronic acid at two molecular weights is made by fermentation. So is Sodium PCA in the Light Moisturiser, part of the skin’s own moisturising factor.',
      'made.PC.3.process': 'The organic base',
      'made.PC.3.head': 'Aloe juice where most creams list water',
      'made.PC.3.text': 'Organic aloe juice, jojoba oil and organic mango seed butter. This part is botanical, not biotech, and we say so.',
      'made.PC.3.textL': 'Organic aloe juice, jojoba oil and African mango butter. This part is botanical, not biotech, and we say so.',
      'made.PC.4.process': 'The first step',
      'made.PC.4.head': 'An oil that turns to milk',
      'made.PC.4.text': 'The Oil-To-Milk Cleanser is not a biotech product either: an oil cleanser with organic sunflower oil and organic camomile, cloudberry and sea buckthorn extracts. It contains a light fragrance.',
      'made.BR.head': 'A plant extract, with fermentation-made hydrators around it.',
      'made.BR.1.process': 'Plant extraction',
      'made.BR.1.head': 'Bidens pilosa extract',
      'made.BR.1.text': 'The lead active is an extract of Bidens pilosa, used as a plant-based alternative to retinol. It is a plant extract, not a biotech ingredient.',
      'made.BR.2.process': 'Fermentation',
      'made.BR.2.head': 'Hyaluronic acid at two molecular weights',
      'made.BR.2.headE': 'Three fermentation-made ingredients',
      'made.BR.2.text': 'Hyaluronic acid at two molecular weights is made by fermentation.',
      'made.BR.2.textE': 'Hyaluronic acid at two molecular weights is made by fermentation. The Elixir adds Sodium PCA and a marine exopolysaccharide made by Alteromonas fermentation.',
      'made.BR.3.process': 'Not biotech',
      'made.BR.3.head': 'The botanical base',
      'made.BR.3.headE': 'A lipo-amino acid',
      'made.BR.3.text': 'Organic aloe juice and plant butters form the base.',
      'made.BR.3.textS': 'Organic aloe juice, rosehip oil and sea buckthorn extract are the botanical part of the Serum.',
      'made.BR.3.textE': 'Dipalmitoyl Hydroxyproline in the Elixir is a lipo-amino acid made by synthesis. Organic aloe juice and plant butters form the base.',
      'made.BR.3.textES': 'Dipalmitoyl Hydroxyproline in the Elixir is a lipo-amino acid made by synthesis. Organic aloe juice, rosehip oil and sea buckthorn extract are the botanical part of the Serum.',

      /* inside: ingredient cards */
      'in.level.strong': 'strong',
      'in.level.moderate': 'moderate',
      'in.level.supplier': 'supplier data',
      'in.water.tag': 'The water-binders',
      'in.water.name': 'Glycerin + two hyaluronic acids',
      'in.water.what': 'Glycerin pulls water into the outer layer. One hyaluronic acid holds it on the surface, a smaller hydrolysed one in the upper layer.',
      'in.water.whatPCA': 'Glycerin pulls water into the outer layer. One hyaluronic acid holds it on the surface, a smaller hydrolysed one in the upper layer. Sodium PCA adds to them.',
      'in.water.proof': 'Glycerin is the best-documented humectant in dermatology; hyaluronic acid has several clinical studies behind it.',
      'in.PC.head': 'Calm and water in the same cream.',
      'in.algae.tag': 'The calming active',
      'in.algae.name': 'Enzymatically hydrolysed red algae',
      'in.algae.what': 'Sugars from red seaweed, cut into smaller fractions by enzymes. In both creams.',
      'in.algae.proof': 'So far the evidence comes from the ingredient supplier, so we only say “helps calm the look of redness”.',
      'in.lipid.tag': 'The lipid layer',
      'in.lipid.name': 'Jojoba + mango seed butter',
      'in.lipid.what': 'A liquid plant wax and a soft butter in the Night Recovery Cream. They soften rough patches and slow water loss while you sleep.',
      'in.lipid.proof': 'Emollients reliably soften skin. This is a plant lipid layer, not an occlusive balm.',
      'in.aloe.tag': 'The base',
      'in.aloe.name': 'Aloe leaf juice',
      'in.aloe.what': 'Organic aloe juice is the first ingredient where most creams list water.',
      'in.aloe.proof': 'Formulas with aloe extract raise the water content of the outer skin layer in human tests.',
      'in.PC.leftHead': 'Why essential-oil-free matters for sensitive skin',
      'in.BR.head': 'A plant extract and the water-binders around it.',
      'in.bidens.tag': 'The lead active',
      'in.bidens.name': 'Bidens pilosa extract',
      'in.bidens.what': 'A plant-based alternative to retinol. Helps smooth the look of fine lines and refine skin texture.',
      'in.bidens.proof': 'The evidence comes from the ingredient supplier’s own studies, without a placebo group. Retinol itself is better studied.',
      'in.dhp.tag': 'For firmness',
      'in.dhp.name': 'Dipalmitoyl Hydroxyproline',
      'in.dhp.what': 'A lipo-amino acid in the Elixir. Helps skin feel firmer and look smoother.',
      'in.dhp.proof': 'One supplier study with a placebo group.',
      'in.BR.leftHead': 'What you should know before you start',
      'in.BR.leftText': 'Contains a natural fragrance with geranium essential oil. If your skin reacts to fragranced products, choose PURE CALM. Before first use, patch test on the inner forearm or behind the ear twice a day for 5–7 days. Not for the eyelids, irritated skin or skin just after a procedure.',

      /* what to expect */
      'ex.PC.head': 'Comfort first. Calmer-looking skin with time.',
      'ex.PC.1.when': 'First use',
      'ex.PC.1.head': 'Comfort',
      'ex.PC.1.text': 'Humectants bind water at the surface, so skin feels less tight soon after you apply the cream.',
      'ex.PC.2.when': 'Weeks 1–2',
      'ex.PC.2.head': 'Fewer triggers',
      'ex.PC.2.text': 'No acids, no retinol, and a cream without fragrance or essential oils: there is simply less for skin to react to.',
      'ex.PC.2.textR1': 'No acids, no retinol, and creams without fragrance or essential oils: there is simply less for skin to react to.',
      'ex.PC.3.when': 'Weeks 2–4',
      'ex.PC.3.head': 'Check in',
      'ex.PC.3.text': 'Compare with day one. If something still stings or stays red, see a dermatologist.',
      'ex.PC.3.textReask': 'Compare with day one, then take the questions again: your answers may have changed.',
      'ex.PC.foot': 'Individual results vary. PURE CALM is a cosmetic moisturiser, not a treatment.',
      'ex.BR.head': 'Hydration at once. Lines take weeks.',
      'ex.BR.1.when': 'Before first use',
      'ex.BR.1.head': 'Patch test',
      'ex.BR.1.text': 'Inner forearm or behind the ear, twice a day for 5–7 days.',
      'ex.BR.2.when': 'First weeks',
      'ex.BR.2.head': 'Hydration',
      'ex.BR.2.text': 'The same water-binders as in our moisturisers: skin feels less tight from the first uses.',
      'ex.BR.3.when': 'Weeks 8–12',
      'ex.BR.3.head': 'The look of fine lines',
      'ex.BR.3.text': 'Give it 8–12 weeks before you judge. A cream softens how lines look; it does not remove them.',
      'ex.BR.foot': 'Individual results vary. Retinol is better studied than Bidens pilosa: this is an alternative for skin that retinol did not suit.',

      /* routine steps */
      'step.sun_own': 'Sunscreen: your own, every morning',
      'step.sun_stick': 'Sun Protection SPF50 Stick',
      'step.own': 'Your usual gentle cleanser',
      'step.own_rinse': 'Your usual gentle cleanser, or a rinse with lukewarm water',
      'step.C': 'Oil-To-Milk Cleanser',
      'step.L_damp': 'PURE CALM Light Moisturiser on slightly damp skin',
      'step.L': 'PURE CALM Light Moisturiser',
      'step.N': 'PURE CALM Night Recovery Cream',
      'step.day_cream': 'Your usual day cream',
      'step.rest': 'Nothing else. Let skin rest',
      'step.gentle': 'Gentle cleanse',
      'step.S_am': 'Bio-Retinol Serum, not on the eyelids',
      'step.S': 'Bio-Retinol Serum',
      'step.E_am': 'Bio-Retinol Elixir Moisturiser, not on the eyelids',
      'step.E': 'Bio-Retinol Elixir Moisturiser',
      'step.E_over': 'Bio-Retinol Elixir Moisturiser over it',
      'step.no_acids': 'No acids or retinol on top',

      /* trust lines */
      'trust.BR': 'Natural fragrance · ECOCERT certified · Made in France & Latvia',
      'trust.R1': 'Fragrance-free, essential-oil-free creams · Lightly fragranced cleanser · ECOCERT certified · Made in France & Latvia',
      'trust.PC': 'Fragrance-free · Essential-oil-free · ECOCERT certified · Made in France & Latvia'
    };
    COPY['in.PC.leftText'] = 'An essential oil is not one ingredient. It is a mixture of dozens of volatile aromatic molecules, and its composition shifts with the plant, the harvest and the storage. Some of these molecules react with air over time and become stronger skin sensitisers. Sensitive skin has a lower reaction threshold: what other skin does not notice can show up as stinging, heat or redness. None of these molecules is needed to hydrate, soften or calm the skin. So both PURE CALM creams leave them out: no fragrance, no essential oils, none of the fragrance allergens that EU rules require on the label.';
    COPY['in.PC.leftTextR1'] = 'An essential oil is not one ingredient. It is a mixture of dozens of volatile aromatic molecules, and its composition shifts with the plant, the harvest and the storage. Some of these molecules react with air over time and become stronger skin sensitisers. Sensitive skin has a lower reaction threshold: what other skin does not notice can show up as stinging, heat or redness. None of these molecules is needed to hydrate, soften or calm the skin. So both PURE CALM creams leave them out: no fragrance, no essential oils, none of the fragrance allergens that EU rules require on the label. The Oil-To-Milk Cleanser is a different case: it contains a light fragrance, and it is rinsed off rather than left on.';
    /* the translation of the current language, if any (window.EPFunnelCopy, set by the theme before this file) */
    var LOC = (typeof window !== 'undefined' && window.EPFunnelCopy) || {};
    var t = function (k) { var v = LOC[k]; return typeof v === 'string' && v !== '' ? v : COPY[k]; };

    var P = {
      C: { id: 'C', name: t('p.C.name'), price: 48.50, size: '', img: IMG.oil, cap: t('p.C.cap'), about: t('p.C.about') },
      L: { id: 'L', name: t('p.L.name'), price: 52.50, size: '50 ml', img: IMG.light, cap: t('p.L.cap') },
      N: { id: 'N', name: t('p.N.name'), price: 58.00, size: '50 ml', img: IMG.night, cap: t('p.N.cap') },
      S: { id: 'S', name: t('p.S.name'), price: 62.30, size: '30 ml', img: IMG.serum, cap: t('p.S.cap') },
      E: { id: 'E', name: t('p.E.name'), price: 58.60, size: '50 ml', img: IMG.elixir, cap: t('p.E.cap') },
      DUO: { id: 'DUO', name: t('p.DUO.name'), price: 99.00, size: t('p.DUO.size'), img: IMG.duo, cap: t('p.DUO.cap') },
      SPF: { id: 'SPF', name: t('p.SPF.name'), price: 38.50, size: '', img: IMG.spf, cap: '' }
    };

    /* ---------- the ten questions: S1–S3 sensitivity stage, Q1–Q7 the fork. Ids are those of funnel_config.json.
       Built from COPY: option values and their order are the logic, the words come from the dictionary ---------- */
    var QDEF = {
      S1: { opts: ['derm', 'many_products', 'after_acids', 'weather', 'selective', 'just_in_case'], refl: ['derm', 'many_products', 'after_acids', 'weather', 'selective', 'just_in_case'] },
      S2: { multi: true, opts: ['sting_minutes', 'redness_hours', 'tight_flaky', 'redness_days', 'rash_itch'], refl: ['ok', 'alarm'] },
      S3: { opts: ['almost_every', 'sometimes', 'rarely'], refl: ['almost_every', 'sometimes', 'rarely'] },
      Q1: { opts: ['avoid', 'dislike', 'neutral', 'like'], refl: ['avoid', 'dislike', 'neutral', 'like'] },
      Q2: { opts: ['often', 'sometimes', 'rarely'], refl: ['often', 'sometimes', 'rarely'] },
      Q3: { opts: ['derm', 'pregnancy', 'none'], refl: ['derm', 'pregnancy', 'none'] },
      Q4: { opts: ['yes', 'no'], refl: ['yes', 'no'] },
      Q5: { opts: ['comfort', 'hydration', 'barrier', 'first_wrinkles', 'marked_wrinkles'], refl: ['comfort', 'hydration', 'barrier', 'first_wrinkles', 'marked_wrinkles'] },
      Q6: { opts: ['oily', 'combination', 'normal', 'dry', 'very_dry'], refl: ['oily', 'combination', 'normal', 'dry', 'very_dry'] },
      Q7: { opts: ['tolerate', 'quit', 'never'], refl: ['tolerate', 'quit', 'never'] }
    };
    var Q = {};
    Object.keys(QDEF).forEach(function (id) {
      var d = QDEF[id], q = { id: id };
      if (d.multi) q.multi = true;
      q.q = t('q.' + id + '.q'); q.hint = t('q.' + id + '.hint');
      q.opts = d.opts.map(function (v) { return [v, t('q.' + id + '.o.' + v)]; });
      q.refl = {}; d.refl.forEach(function (v) { q.refl[v] = v === 'derm' ? t('q.derm') : t('q.' + id + '.r.' + v); });
      Q[id] = q;
    });
    var ALARM = { redness_days: 1, rash_itch: 1 };
    var hasAlarm = function (xs) { return (xs || []).filter(function (x) { return ALARM[x]; }).length > 0; };
    var labelOf = function (id, v) {
      var q = Q[id];
      if (q.multi) return (v || []).map(function (x) { return q.opts.filter(function (o) { return o[0] === x; })[0][1]; }).join(t('q.sep'));
      var f = q.opts.filter(function (o) { return o[0] === v; })[0]; return f ? f[1] : '';
    };
    var reflOf = function (id, v) { var q = Q[id]; if (q.multi) return hasAlarm(v) ? q.refl.alarm : q.refl.ok; return q.refl[v] || ''; };
    var merge = function (a, b) { var n = {}, k; for (k in a) n[k] = a[k]; for (k in b) n[k] = b[k]; return n; };

    /* ---------- sensitivity stage folded into the fork answers ---------- */
    var normalise = function (a0) {
      var a = merge({}, a0), st = '';
      if (a.S1 === 'derm' || hasAlarm(a.S2)) { a.Q3 = 'derm'; return { a: a, stype: 'K' }; }
      if (a.S1 === 'many_products') st = 'R'; else if (a.S1 === 'after_acids') st = 'P'; else if (a.S1 === 'weather') st = 'W'; else if (a.S1 === 'selective') st = 'I'; else if (a.S1 === 'just_in_case') st = 'N';
      if ((st === 'W' || st === 'I' || st === 'N') && a.S3 === 'almost_every') st = 'R';
      if (st === 'R') a.Q2 = 'often';
      else if (st === 'P') a.Q4 = 'yes';
      else if ((st === 'W' || st === 'I' || st === 'N') && !a.Q2) { if (a.S3 === 'sometimes') a.Q2 = 'sometimes'; else if (a.S3 === 'rarely' || st === 'N') a.Q2 = 'rarely'; }
      return { a: a, stype: st };
    };
    var LINE = { R1: 'PC', R2: 'PC', R3: 'PC', R4: 'BR', R5: 'BR', R6: 'BR' };
    var PRODS = { R1: ['C', 'L', 'N'], R2: ['L'], R3: ['N'], R4: ['S'], R5: ['E'], R6: ['DUO'] };

    /* ---------- the 17 rules of map version 4, checked in this order: 1, 2, 3, 4, 5, 6, 7, 15, 13/14, 8–12, 16/17 (as in funnel_resolver.py).
       hard = sensitivity confirmed (type R or P, Q2 often, Q4 yes) -> always R1. soft = PURE CALM filter without confirmed sensitivity
       (Q1 avoid/dislike, Q3 pregnancy): the goal still picks inside PURE CALM, a wrinkle goal gets R1, Bio-Retinol is never shown. ---------- */
    var resolve = function (a0, cfg) {
      var n = normalise(merge(cfg.preset || {}, a0)), a = n.a, def = cfg.def || 'R1';
      var notes = {};
      var out = function (code, rule, trig) {
        var line = LINE[code] || '';
        if (line === 'BR') { notes.patch = 1; notes.fragrance = 1; }
        if (line === 'PC') notes.eofree = 1;
        if (code === 'R1') notes.cleanser = 1;
        if (line) notes.spf = 1;
        if (line && a.Q3 === 'pregnancy') notes.doctor = 1;
        return { code: code, exit: !line, line: line, products: PRODS[code] || [], rule: rule, trig: trig || '', stype: n.stype, notes: notes, eff: a };
      };
      if (a.Q3 === 'derm') return out('EXIT_DOCTOR', 1);
      if (a.Q6 === 'very_dry') return out('EXIT_VERY_DRY', 2);
      var hard = n.stype === 'R' || n.stype === 'P' || a.Q2 === 'often' || a.Q4 === 'yes';
      var scent = a.Q1 === 'avoid' || a.Q1 === 'dislike';
      var soft = scent || a.Q3 === 'pregnancy';
      var softTrig = scent ? 'fragrance' : soft ? 'pregnancy' : '';
      if (hard) {
        if (a.Q4 === 'yes' || n.stype === 'R' || n.stype === 'P') notes.reask = 1;
        return out('R1', 3, a.Q2 === 'often' ? 'reactive' : 'irritated');
      }
      if (a.Q5 === 'comfort') return out('R1', 4, softTrig);
      if (a.Q5 === 'hydration') return out('R2', 5, softTrig);
      if (a.Q5 === 'barrier') return out('R3', 6, softTrig);
      var wr = !cfg.pcOnly && (a.Q5 === 'first_wrinkles' || a.Q5 === 'marked_wrinkles');
      if (soft && wr) return out('R1', 7, softTrig);
      if (wr && a.Q7 === 'tolerate') return out('EXIT_RETINOL_OK', 15);
      var oily = a.Q6 === 'oily' || a.Q6 === 'combination';
      if (wr) {
        if (a.Q2 === 'sometimes') return a.Q6 === 'dry' ? out('R5', 14) : out('R4', 13);
        if (a.Q5 === 'first_wrinkles') return oily ? out('R4', 8) : a.Q6 === 'dry' ? out('R5', 10) : out('R6', 9);
        return oily ? out('R4', 11) : out('R6', 12);
      }
      if (LINE[def] === 'BR') {
        if (soft || cfg.pcOnly) return out('R1', 16, softTrig || 'family');
        return oily ? out('R4', 17) : out(def, 17);
      }
      return out(def, 16, softTrig || (cfg.pcOnly ? 'family' : ''));
    };

    /* ---------- which questions to ask. cfg: { order: ['Q5','Q3',…], sMode: 'first' | 'short' | 'onAnswer', preset: {…}, pcOnly: bool, def: 'R1' } ---------- */
    var plan = function (a0, cfg) {
      var pre = cfg.preset || {}, a = merge(pre, a0), seq = [];
      if (cfg.sMode === 'first') seq = ['S1', 'S2', 'S3'];
      if (cfg.sMode === 'short') seq = ['S2', 'S3'];
      cfg.order.forEach(function (id) { seq.push(id); if (cfg.sMode === 'onAnswer' && id === 'Q2') { seq.push('S1'); seq.push('S2'); seq.push('S3'); } });
      var e = normalise(a).a;
      var has = function (id) { return a0[id] !== undefined; };
      var hard = e.Q2 === 'often' || e.Q4 === 'yes';
      var soft = e.Q1 === 'avoid' || e.Q1 === 'dislike' || e.Q3 === 'pregnancy';
      var wr = e.Q5 === 'first_wrinkles' || e.Q5 === 'marked_wrinkles';
      var over = e.Q3 === 'derm' || e.Q6 === 'very_dry' || (!hard && !soft && !cfg.pcOnly && wr && e.Q7 === 'tolerate');
      var ask = seq.filter(function (id) {
        if (has(id)) return true;
        if (pre[id] !== undefined) return false;
        if (over) return false;
        if (id === 'S1' || id === 'S2' || id === 'S3') return cfg.sMode !== 'onAnswer' || a.Q2 === 'often' || a.Q2 === 'sometimes' || a.Q4 === 'yes';
        if (id === 'Q2') return cfg.sMode === 'onAnswer' && e.Q4 !== 'yes';
        if (id === 'Q4') return a.S1 !== 'after_acids' && e.Q2 !== 'often';
        if (id === 'Q1') return !cfg.pcOnly && !hard && e.Q3 !== 'pregnancy';
        if (id === 'Q5') return !cfg.pcOnly && !hard;
        if (id === 'Q7') return !cfg.pcOnly && !hard && !soft && wr;
        return true;
      });
      var missing = ask.filter(function (id) { return !has(id); });
      return { ask: ask, missing: missing, done: missing.length === 0 };
    };

    /* ---------- copy: outcomes, exits, card lines, tabs ---------- */
    var OUT = {};
    ['R1', 'R2', 'R3', 'R4', 'R5', 'R6'].forEach(function (c) { OUT[c] = { title: t('out.' + c + '.title'), short: t('out.' + c + '.short'), lead: t('out.' + c + '.lead'), cta: t('out.' + c + '.cta'), bio: t('out.' + c + '.bio') }; });
    var EXIT = {};
    ['DOCTOR', 'VERY_DRY', 'RETINOL_OK'].forEach(function (x) { EXIT['EXIT_' + x] = { head: t('exit.' + x + '.head'), text: t('exit.' + x + '.text'), sub: t('exit.' + x + '.sub') }; });
    var NOTE = {};
    ['eofree', 'cleanser', 'cleanserAvoid', 'cleanserDislike', 'fragrance', 'patch', 'spf', 'doctor', 'reask', 'full'].forEach(function (k) { NOTE[k] = t('note.' + k); });
    var TYPE = { K: { name: t('type.K.name'), diag: '' } };
    ['R', 'P', 'W', 'I', 'N'].forEach(function (k) { TYPE[k] = { name: t('type.' + k + '.name'), diag: t('type.' + k + '.diag') }; });
    /* the cleanser line of an R1 outcome; '' for every other outcome. scentAverse: the visitor said so in Q1 */
    var scentAverse = function (r) { return r.eff.Q1 === 'avoid' || r.eff.Q1 === 'dislike'; };
    var cleanserNote = function (r) { if (r.code !== 'R1') return ''; return r.eff.Q1 === 'avoid' ? NOTE.cleanserAvoid : r.eff.Q1 === 'dislike' ? NOTE.cleanserDislike : NOTE.cleanser; };
    var whyYou = function (r, general) {
      if (general && (r.rule === 16 || r.rule === 17)) return t('why.general');
      if (r.code === 'R1') {
        if (r.trig === 'reactive') return t('why.R1.reactive');
        if (r.trig === 'irritated') return t('why.R1.irritated');
        if (r.rule === 7 && r.trig === 'fragrance') return t('why.R1.scent');
        if (r.rule === 7) return t('why.R1.pregnancy');
        if (r.rule === 4) return t('why.R1.comfort');
        return t('why.R1.default');
      }
      if (r.code === 'R2') return r.rule === 5 ? t('why.R2.asked') : t('why.R2.default');
      if (r.code === 'R3') return r.rule === 6 ? t('why.R3.asked') : t('why.R3.default');
      if (r.rule === 13 || r.rule === 14) return r.code === 'R5' ? t('why.BR.sometimes_E') : t('why.BR.sometimes_S');
      if (r.code === 'R4') return t('why.R4');
      if (r.code === 'R5') return t('why.R5');
      return t('why.R6');
    };
    var cardLines = function (r, general) {
      var good = t('card.good.BR');
      if (r.code === 'R1') good = !scentAverse(r) ? t('card.good.R1') : r.eff.Q1 === 'avoid' ? t('card.good.R1avoid') : t('card.good.R1dislike');
      else if (r.line === 'PC') good = t('card.good.PC');
      return [
        { label: t('card.why'), text: whyYou(r, general) },
        { label: t('card.bio'), text: OUT[r.code].bio },
        { label: t('card.good'), text: good }
      ];
    };
    var made = function (r) {
      var hasL = r.products.indexOf('L') >= 0, hasE = r.products.indexOf('E') >= 0 || r.products.indexOf('DUO') >= 0, hasS = r.products.indexOf('S') >= 0 || r.products.indexOf('DUO') >= 0;
      if (r.line === 'PC') return { head: t('made.PC.head'), rows: [
        { n: '01', process: t('made.PC.1.process'), head: t('made.PC.1.head'), text: t('made.PC.1.text') },
        { n: '02', process: t('made.PC.2.process'), head: hasL ? t('made.PC.2.headL') : t('made.PC.2.head'), text: hasL ? t('made.PC.2.textL') : t('made.PC.2.text') },
        { n: '03', process: t('made.PC.3.process'), head: t('made.PC.3.head'), text: hasL ? t('made.PC.3.textL') : t('made.PC.3.text') }
      ].concat(r.code === 'R1' ? [{ n: '04', process: t('made.PC.4.process'), head: t('made.PC.4.head'), text: t('made.PC.4.text') }] : []),
        foot: t('made.foot') };
      return { head: t('made.BR.head'), rows: [
        { n: '01', process: t('made.BR.1.process'), head: t('made.BR.1.head'), text: t('made.BR.1.text') },
        { n: '02', process: t('made.BR.2.process'), head: hasE ? t('made.BR.2.headE') : t('made.BR.2.head'), text: hasE ? t('made.BR.2.textE') : t('made.BR.2.text') },
        { n: '03', process: t('made.BR.3.process'), head: hasE ? t('made.BR.3.headE') : t('made.BR.3.head'), text: hasE ? (hasS ? t('made.BR.3.textES') : t('made.BR.3.textE')) : (hasS ? t('made.BR.3.textS') : t('made.BR.3.text')) }
      ], foot: t('made.foot') };
    };
    var inside = function (r) {
      var hasL = r.products.indexOf('L') >= 0, hasN = r.products.indexOf('N') >= 0, hasE = r.products.indexOf('E') >= 0 || r.products.indexOf('DUO') >= 0;
      var card = function (k, level) { return { tag: t('in.' + k + '.tag'), name: t('in.' + k + '.name'), what: t('in.' + k + '.what'), level: t('in.level.' + level), proof: t('in.' + k + '.proof') }; };
      var water = card('water', 'strong'); if (hasL || hasE) water.what = t('in.water.whatPCA');
      if (r.line === 'PC') {
        var cs = [card('algae', 'supplier'), water];
        cs.push(hasN ? card('lipid', 'moderate') : card('aloe', 'moderate'));
        return { head: t('in.PC.head'), cards: cs, leftHead: t('in.PC.leftHead'), leftText: r.code === 'R1' ? t('in.PC.leftTextR1') : t('in.PC.leftText') };
      }
      var bs = [card('bidens', 'supplier'), water];
      if (hasE) bs.push(card('dhp', 'supplier'));
      return { head: t('in.BR.head'), cards: bs, leftHead: t('in.BR.leftHead'), leftText: t('in.BR.leftText') };
    };
    var expect = function (r) {
      var st = function (p, i, text) { return { when: t('ex.' + p + '.' + i + '.when'), head: t('ex.' + p + '.' + i + '.head'), text: text || t('ex.' + p + '.' + i + '.text') }; };
      if (r.line === 'PC') return { head: t('ex.PC.head'), stages: [
        st('PC', 1), st('PC', 2, r.code === 'R1' ? t('ex.PC.2.textR1') : ''), st('PC', 3, r.notes.reask ? t('ex.PC.3.textReask') : '')
      ], foot: t('ex.PC.foot') };
      return { head: t('ex.BR.head'), stages: [st('BR', 1), st('BR', 2), st('BR', 3)], foot: t('ex.BR.foot') };
    };
    var steps = function (code, spfOn) {
      var sun = spfOn && LINE[code] === 'BR' ? t('step.sun_stick') : t('step.sun_own');
      var x = {
        R1: [[[t('step.C'), 'C'], [t('step.L_damp'), 'L'], [sun]], [[t('step.C'), 'C'], [t('step.N'), 'N'], [t('step.rest')]]],
        R2: [[[t('step.own_rinse')], [t('step.L_damp'), 'L'], [sun]], [[t('step.own')], [t('step.L'), 'L'], [t('step.rest')]]],
        R3: [[[t('step.own_rinse')], [t('step.day_cream')], [sun]], [[t('step.own')], [t('step.N'), 'N'], [t('step.rest')]]],
        R4: [[[t('step.gentle')], [t('step.S_am'), 'S'], [sun]], [[t('step.gentle')], [t('step.S'), 'S'], [t('step.no_acids')]]],
        R5: [[[t('step.gentle')], [t('step.E_am'), 'E'], [sun]], [[t('step.gentle')], [t('step.E'), 'E'], [t('step.no_acids')]]],
        R6: [[[t('step.gentle')], [t('step.S_am'), 'S'], [t('step.E_over'), 'E'], [sun]], [[t('step.gentle')], [t('step.S'), 'S'], [t('step.E_over'), 'E']]]
      }[code];
      var mk = function (xs) { return xs.map(function (s, i) { return { n: '0' + (i + 1), t: s[0], cap: s[1] ? P[s[1]].cap : '', hasCap: !!s[1] }; }); };
      return { am: mk(x[0]), pm: mk(x[1]) };
    };
    /* variants a visitor may switch between on the routine screen. PURE CALM has none: R1 is always the same three products,
       R2 and R3 are the answer to one need. Bio-Retinol variants stay inside the line, as before */
    var allowed = function (r) {
      if (r.line === 'PC') return [r.code];
      if (r.rule === 13 || r.rule === 14) return [r.code];
      if (r.eff.Q6 === 'oily' || r.eff.Q6 === 'combination') return ['R4'];
      return ['R6', 'R4', 'R5'];
    };
    var trust = function (line, code) {
      if (line === 'BR') return t('trust.BR');
      if (code === 'R1') return t('trust.R1');
      return t('trust.PC');
    };
    return { IMG: IMG, P: P, Q: Q, OUT: OUT, EXIT: EXIT, NOTE: NOTE, TYPE: TYPE, LINE: LINE, PRODS: PRODS, COPY: COPY, t: t,
      labelOf: labelOf, reflOf: reflOf, hasAlarm: hasAlarm, normalise: normalise, resolve: resolve, plan: plan,
      whyYou: whyYou, cardLines: cardLines, cleanserNote: cleanserNote, scentAverse: scentAverse, made: made, inside: inside, expect: expect, steps: steps, allowed: allowed, trust: trust };
  }
  };
  return holder.kit();
})();
